import en from '@/locales/config/en.json'
import tw from '@/locales/config/tw.json'
import tc from '@/locales/config/TC.json'
import ch from '@/locales/config/ch.json'
import japanese from '@/locales/config/japanese.json';
import dutch from '@/locales/config/dutch.json';
import french from '@/locales/config/french.json';
import german from '@/locales/config/german.json';
import indonesian from '@/locales/config/indonesian.json';
import italian from '@/locales/config/italian.json';
import korean from '@/locales/config/korean.json';
import polish from '@/locales/config/polish.json';
import romanian from '@/locales/config/romanian.json';
import russian from '@/locales/config/russian.json';
import spanish from '@/locales/config/spanish.json';
import swedish from '@/locales/config/swedish.json';
import thai from '@/locales/config/thai.json';
import turkish from '@/locales/config/turkish.json';
import ukrainian from '@/locales/config/ukrainian.json';
import vietnamese from '@/locales/config/vietnamese.json';


// import lang from '@/locales/config/variable.js'

export default {
  en,
  tw,
  tc,
  ch,
  japanese,
  dutch,
  french,
  german,
  indonesian,
  italian,
  korean,
  polish,
  romanian,
  russian,
  spanish,
  swedish,
  thai,
  turkish,
  ukrainian,
  vietnamese,
  // lang
}


